<style>
	.vs-card--content {
		margin-bottom: 0;
	}

	.vs-con-textarea {
		margin-bottom: 0;
	}

	.vx-input-group .vx-input-group-default:not(:last-child) input {
		border-right-color: rgba(0, 0, 0, 0) !important;
	}
</style>

<template>
	<div>
		<div class="vx-col w-full mb-base">
			<vs-card class="p-4 mb-6">
				<div slot="header" class="flex flex-wrap items-center justify-between">
					<div class="flex items-center">
						<vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
						<h4 style="margin-left: 10px">Stock Check Details</h4>
					</div>
					<div class="flex items-center">
						<vs-button class="btn mr-1" @click="finishCount">Finish Count</vs-button>
					</div>
				</div>
				<div class="vx-row mt-6">
					<div class="vx-col lg:w-1/4 w-full">
						<div class="vx-row mb-3">
							<div class="vx-col w-1/3">
								Reference*
							</div>
							<div class="vx-col w-2/3">
								<vs-input class="w-full" v-model="data.reference" disabled/>
							</div>
						</div>
						<div class="vx-row mb-3 mt-1">
							<div class="vx-col w-1/3">
								Check Date*
							</div>
							<div class="vx-col w-2/3">
								<flat-pickr class="w-full" v-model="data.check_date" disabled/>
							</div>
						</div>
					</div>
					<div class="vx-col lg:w-1/4 w-full">
						<div class="vx-row mb-3 mt-1">
							<div class="vx-col w-1/3">
								Client ID*
							</div>
							<div class="vx-col w-2/3">
								<vx-input-group>
									<vs-input v-model="data.client_code" disabled/>
									<template slot="append">
										<div class="append-text btn-addon">
											<vs-button
												disabled
												size="small"
												color="primary"
												icon-pack="feather"
												icon="icon-search"
												type="border"
											></vs-button>
										</div>
									</template>
								</vx-input-group>
							</div>
						</div>
						<div class="vx-row mb-3 mt-1">
							<div class="vx-col w-1/3">
								Warehouse ID*
							</div>
							<div class="vx-col w-2/3">
								<vx-input-group>
									<vs-input v-model="data.warehouses_code" disabled/>
									<template slot="append">
										<div class="append-text btn-addon">
											<vs-button
												disabled
												size="small"
												color="primary"
												icon-pack="feather"
												type="border"
												icon="icon-search"
											></vs-button>
										</div>
									</template>
								</vx-input-group>
							</div>
						</div>
					</div>
				</div>
				<vs-tabs class="mt-10">
					<vs-tab label="Scan">
						<div class="vx-row mt-6">
							<div class="vx-col lg:w-1/4">
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										No.
									</div>
									<div class="vx-col w-2/3">
										<vs-input class="w-full" v-model="params.no" @keyup.enter="search" :disabled="lock"/>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Location ID
									</div>
									<div class="vx-col w-2/3">
										<vx-input-group>
											<vs-input v-model="params.location_code" :disabled="lock"/>
											<template slot="append">
												<div class="append-text btn-addon">
													<vs-button
														:disabled="lock"
														size="small"
														color="primary"
														icon-pack="feather"
														icon="icon-search"
														type="border"
													></vs-button>
												</div>
											</template>
										</vx-input-group>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Product ID
									</div>
									<div class="vx-col w-2/3">
										<vx-input-group>
											<vs-input v-model="params.product_code" :disabled="lock"/>
											<template slot="append">
												<div class="append-text btn-addon">
													<vs-button
														:disabled="lock"
														size="small"
														color="primary"
														icon-pack="feather"
														icon="icon-search"
														type="border"
													></vs-button>
												</div>
											</template>
										</vx-input-group>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Qty
									</div>
									<div class="vx-col w-2/3">
										<vs-input class="w-full" v-model="params.qty" @keyup.enter="search"/>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										UoM
									</div>
									<div class="vx-col w-2/3">
										<vx-input-group>
											<vs-input v-model="params.base_uom"/>
											<template slot="append">
												<div class="append-text btn-addon">
													<vs-button
														size="small"
														color="primary"
														icon-pack="feather"
														icon="icon-search"
														type="border"
													></vs-button>
												</div>
											</template>
										</vx-input-group>
									</div>
								</div>
							</div>
							<div class="vx-col lg:w-1/4">
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Stock Type
									</div>
									<div class="vx-col w-2/3">
										<vx-input-group>
											<vs-input v-model="params.stock_type" :disabled="lock"/>
											<template slot="append">
												<div class="append-text btn-addon">
													<vs-button
														:disabled="lock"
														size="small"
														color="primary"
														icon-pack="feather"
														icon="icon-search"
														type="border"
													></vs-button>
												</div>
											</template>
										</vx-input-group>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Storage Unit
									</div>
									<div class="vx-col w-2/3">
										<vs-input class="w-full" v-model="params.storage_unit" @keyup.enter="search" :disabled="lock"/>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Pack ID
									</div>
									<div class="vx-col w-2/3">
										<vs-input class="w-full" v-model="params.pack_id" @keyup.enter="search" :disabled="lock"/>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Batch
									</div>
									<div class="vx-col w-2/3">
										<vs-input class="w-full" v-model="params.batch" @keyup.enter="search" :disabled="lock"/>
									</div>
								</div>
								<div class="vx-row mb-3">
									<div class="vx-col w-1/3">
										Expired Date
									</div>
									<div class="vx-col w-2/3">
										<flat-pickr class="w-full" v-model="params.expired_date" :disabled="lock"/>
									</div>
								</div>
							</div>
						</div>
						<vs-row vs-type="flex" vs-justify="space-between">
							<vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
								<vs-button class="btn mr-1 mt-5" @click="search" :disabled="lock">Scan</vs-button>
								<vs-button class="btn mr-1 mt-5" @click="reset" :disabled="!lock">Reset</vs-button>
							</vs-col>
							<vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
								<vs-button class="btn mr-1 mt-5" @click="newCount" :disabled="lock">New</vs-button>
								<vs-button class="btn mr-1 mt-5" @click="updateCount" :disabled="!lock">Update</vs-button>
							</vs-col>
						</vs-row>
					</vs-tab>
					<vs-tab label="Checked Items">
						<div>
                            <vs-button type="border" class="btn mr-1 mt-5 mb-5" @click="addNewLine">Add</vs-button>
							<vs-table :data="data.details" hoverFlat>
								<template slot="thead">
                                    <vs-th style="min-width: 70px; width: 70px">Line ID</vs-th>
									<vs-th style="min-width: 200px; width: 200px">Location</vs-th>
									<vs-th style="min-width: 200px; width: 200px">Product</vs-th>
									<vs-th style="min-width: 200px; width: 200px">Description</vs-th>
									<vs-th style="min-width: 120px; width: 120px">Pack ID</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Batch</vs-th>
                                    <vs-th style="min-width: 120px; width: 120px">Exp. Date</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Stock Type</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">Actual Qty</vs-th>
                                    <vs-th style="min-width: 80px; width: 80px">UoM</vs-th>
								</template>
								<template slot-scope="{data}">
									<vs-tr :key="indextr" v-for="(tr, indextr) in data">
										<vs-td>{{ indextr + 1 }}.</vs-td>
										<vs-td v-if="tr.update"><b>{{ tr.location_code }}</b><br><small>{{ tr.location_type }}</small></vs-td>
                                        <vs-td v-else>
                                            <vs-select
                                                class="selectExample mb-2"
                                                v-model="tr.location_id"
                                                width="100%"
                                                autocomplete
                                                @input-change="searchDropdown($event, location)"
                                            >
                                                <vs-select-item v-for="(item, index) in location.data" :key="index" :value="item.id" :text="item.location_code"/>
                                            </vs-select>
                                        </vs-td>
										<vs-td v-if="tr.update"><b>{{ tr.product_code }}</b></vs-td>
                                        <vs-td v-else>
                                            <vs-select
                                                class="selectExample mb-2"
                                                v-model="tr.product_id"
                                                @input="productChange(tr)"
                                                width="100%"
                                                autocomplete
                                                @input-change="searchProduct"
                                            >
                                                <vs-select-item v-for="(item, index) in product" :key="index" :value="item.id" :text="item.product_code"/>
                                            </vs-select>
                                        </vs-td>
										<vs-td>{{ tr.description }}</vs-td>
										<vs-td v-if="tr.update">{{ tr.pack_id }}</vs-td>
										<vs-td v-else><vs-input class="w-full" v-model="tr.pack_id"/></vs-td>
										<vs-td v-if="tr.update">{{ tr.batch }}</vs-td>
										<vs-td v-else><vs-input class="w-full" v-model="tr.batch"/></vs-td>
										<vs-td v-if="tr.update">{{ tr.expired_date }}</vs-td>
										<vs-td v-else><vs-input class="w-full" v-model="tr.expired_date"/></vs-td>
										<vs-td v-if="tr.update">{{ tr.stock_type }}</vs-td>
                                        <vs-td v-else>
                                            <vs-select
                                                class="selectExample mb-2"
                                                v-model="tr.stock_type_id"
                                                width="100%"
                                                autocomplete
                                                @input-change="searchDropdown($event, stock_type)"
                                            >
                                                <vs-select-item v-for="(item, index) in stock_type.data" :key="index" :value="item.id" :text="item.name"/>
                                            </vs-select>
                                        </vs-td>
										<vs-td><vs-input class="w-full" v-model="tr.qty" @change="isNumber($event)"/></vs-td>
										<vs-td>
                                            <vs-select
                                                class="selectExample mb-2"
                                                v-model="tr.uom_id"
                                                width="100%"
                                                autocomplete
                                            >
                                                <vs-select-item v-for="(item, index) in tr.uoms" :key="index" :value="item.uom.id" :text="item.uom.name"/>
                                            </vs-select>
                                        </vs-td>
									</vs-tr>
								</template>
							</vs-table>
						</div>
					</vs-tab>
				</vs-tabs>
			</vs-card>
		</div>
	</div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                fetchCount: 0,
                product: [],
                location: {
                    data: [],
                    loading: false,
                    endpoint: 'master/locations',
                    objectKey: 'location_code'
                },
                stock_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/stocktypes',
                    objectKey: 'name'
                },
				lock: false,
				isLoading: false,
				data: {
					reference: '',
					check_date: new Date(),
					warehouses_code: '',
					client_code: '',
				},
				params: {
					id: '',
					no: '',
					pack_id: '',
					batch: '',
					expired_date: '',
					storage_unit: '',
					product_code: '',
					description: '',
					base_uom: '',
					stock_type: '',
					location_code: '',
					location_type: '',
					qty: '',
				},
			}
		},
		watch: {
			isLoading: function(){
				if(this.isLoading){
					this.$vs.loading()
				}
				else{
					this.$vs.loading.close()
				}
			}
		},
		methods:{
			reset() {
				this.params = {
					id: '',
					no: '',
					pack_id: '',
					batch: '',
					expired_date: '',
					storage_unit: '',
					product_code: '',
					description: '',
					stock_type: '',
					location_code: '',
					location_type: '',
					qty: '',
					base_uom: ''
				}

				this.lock = false
			},
			search() {
				if(!this.params.no) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: "Please enter list number to scan."
					});

					return false
				}

				const data = JSON.parse(JSON.stringify(this.params))
				data.id = this.$route.params.id

				if(!this.isLoading) {
					this.isLoading = true
					this.$http.post('inventories/stockcheck/getdetail', data)
					.then(res => {
						this.isLoading = false
						this.params = res.data
						this.lock = true
					})
					.catch(error => {
						this.isLoading = false
						const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
						this.$vs.notify({
							color: "danger",
							title: "Error",
							iconPack: "feather",
							icon: "icon-x",
							text: message
						});
					})
				}
			},
			back() {
				this.$router.push({name: 'stock-check'})
			},
			updateCount() {
				let error = false
				if(!this.params.id) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: "Please scan data first."
					});
					error = true
				}

				if(!this.params.qty) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: "Enter qty."
					});
					error = true
				}

				if(error) {
					return false
				}
				
				if(!this.isLoading) {
					const data = {
						id: this.params.id,
						qty: this.params.qty,
						base_uom: this.params.base_uom
					}
					this.isLoading = true
					this.$http.post('inventories/stockcheck/count', data)
					.then(res => {
						this.isLoading = false
						// this.params = res.data
						// this.lock = true
						this.reset()
						this.$vs.notify({
							color: "success",
							title: "Success",
							iconPack: "feather",
							icon: "icon-check",
							text: "Updated successfully."
						});
					})
					.catch(error => {
						this.isLoading = false
						const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
						this.$vs.notify({
							color: "danger",
							title: "Error",
							iconPack: "feather",
							icon: "icon-x",
							text: message
						});
					})
				}
			},
			newCount() {
				let error = false
				const data = {
					id: this.$route.params.id,
					product_code: this.params.product_code,
					uom: this.params.base_uom,
					stock_type: this.params.stock_type,
					location_code: this.params.location_code,
					pack_id: this.params.pack_id,
					batch: this.params.batch,
					expired_date: this.params.expired_date,
					storage_unit: this.params.storage_unit,
					qty: this.params.qty
				}

				if(!this.params.product_code) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: 'Enter product code.'
					});

					error = true
				}

				if(!this.params.base_uom) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: 'Enter UoM.'
					});

					error = true
				}

				if(!this.params.location_code) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: 'Enter location code.'
					});

					error = true
				}

				if(!this.params.stock_type) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: 'Enter stock type.'
					});

					error = true
				}

				if(!this.params.qty) {
					this.$vs.notify({
						color: "danger",
						title: "Error",
						iconPack: "feather",
						icon: "icon-x",
						text: 'Enter qty.'
					});

					error = true
				}

				if(!error) {
					this.$http.post('inventories/stockcheck/addcount', data)
					.then(res => {
						const message = res.data.message ? res.data.message : 'Added successfully.'
						this.isLoading = false;
						this.$vs.notify({
							color: "success",
							title: "Success",
							iconPack: "feather",
							icon: "icon-check",
							text: message
						});
					})
					.catch(error => {
						const message = error.response.data.message ? error.response.data.message : 'Something went wrong.'
						this.isLoading = false;
						this.$vs.notify({
							color: "danger",
							title: "Error",
							iconPack: "feather",
							icon: "icon-x",
							text: message
						});
					})
				}
			},
			fetchData() {
				this.isLoading = true
				this.$http.post('inventories/stockcheck/getcount', {id: this.$route.params.id})
				.then(res => {
					this.isLoading = false
                    this.data = res.data
                    this.data.details.map(item => {
                        item.uoms = item.product.uoms
                        item.update = true
                    })
				})
				.catch(error => {
					this.isLoading = false
					this.$vs.dialog({
						type: 'confirm',
						color: 'danger',
						title: 'Server Error',
						text: 'Try again?',
						accept: () => {
							this.fetchData()
						},
						cancel: () => this.$router.push({name: 'stock-check'}),
						acceptText: 'Yes',
						cancelText: 'No'
					})
				})
			},
			getData() {
				const data = {
					client_code: this.data.client_code,
					warehouses_code: this.data.warehouses_code,
					location_id: this.params.location_id,
					location_type_id: this.params.location_type_id,
					product_id: this.params.product_id,
					stock_type_id: this.params.stock_type_id,
					storage_unit: this.params.storage_unit,
					include_empty: this.params.include_empty,
					pack_id: this.params.pack_id,
					batch: this.params.batch,
				}

				this.data.details = []

				this.isLoading = true
				this.$http.post('inventories/stockcheck/getdetails', data)
				.then(res => {
					this.isLoading = false
					this.data.details = res.data
				})
				.catch(error => this.handleError(error))
			},
			finishCount() {
				let error = false
				this.data.details.map((item, index) => {
					if(!item.qty || isNaN(item.qty)) {
						this.$vs.notify({
							color: "danger",
							title: "Error",
							iconPack: "feather",
							icon: "icon-x",
							text: `Line ${index + 1} qty is not a number`
						});

						error = true
					}
				})

				if(error) {
					return false
				}

				const data = {
					id: this.data.id,
					details: this.data.details
				}

				this.isLoading = true
				this.$http.post('inventories/stockcheck/finishcount', data)
				.then(res => {
				    this.isLoading = false
				    const message = res.data.message ? res.data.message : 'Success.'
				    this.$vs.notify({
				        color: "success",
				        title: "Success",
				        iconPack: "feather",
				        icon: "icon-check",
				        text: message
				    });

				    this.$router.push({
				        name: 'stock-check-view',
				        params: {
				            id: this.$route.params.id
				        }
				    })
				})
				.catch(error => this.handleError(error))
            },
            addNewLine() {
                if(this.fetchCount < 1) {
                    this.isLoading = true
                    Promise.all([
                        this.$http.post('master/product', { client_id: this.data.client_id }),
                        this.$http.post('master/locations'),
                        this.$http.post('master/stocktypes')
                    ])
                    .then(this.$http.spread((products, locations, stocktypes) => {
                        this.product = products.data.data
                        this.location.data = locations.data.data
                        this.stock_type.data = stocktypes.data.data
                        this.isLoading = false
                        this.fetchCount++

                        this.data.details.push({
                            detail_id: null,
                            location_id: null,
                            product_id: null,
                            stock_type_id: null,
                            pack_id: null,
                            batch: null,
                            expired_date: null,
                            qty: null,
                            update: false,
                            uoms: []
                        })
                    }))
                }
                else {
                    this.data.details.push({
                        detail_id: null,
                        location_id: null,
                        product_id: null,
                        stock_type_id: null,
                        pack_id: null,
                        batch: null,
                        expired_date: null,
                        qty: null,
                        update: false,
                        product: {
                            uoms: []
                        }
                    })
                }
            },
            productChange(tr) {
                const product = this.product[this.product.findIndex(p => p.id === tr.product_id)]
                tr.description = product.description_1
                tr.uoms = product.uoms
                tr.uom_id = product.base_uom.uom_id
            },
            searchProduct(e) {
                const code = e.target.value
                console.log(code)
            }
		},
		mounted(){
			this.fetchData()
		},
	}
</script>